export const downloadFile = (fileName, content, contentType = 'text/csv') => {
    // \uFEFF is for unicode compliance
    const blob = new Blob(['\uFEFF' + content], { type: `${contentType}; charset=UTF-8` });
    if (typeof navigator.msSaveBlob == 'function')
        return navigator.msSaveBlob(blob, fileName);

    var saver = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
    var contentUrl = saver.href = URL.createObjectURL(blob),
        body = document.body;
    saver.download = fileName;

    body.appendChild(saver);
    saver.dispatchEvent(new MouseEvent('click'));
    body.removeChild(saver);
    URL.revokeObjectURL(contentUrl);
};
